document.addEventListener("DOMContentLoaded", function(){
  $(document).on('change', "select[name='employee_work_calendar[employee_id]'], select[name='employee_work_calendar[period_id]']", function(){
    const $employee = $("select[name='employee_work_calendar[employee_id]']")
    const $period = $("select[name='employee_work_calendar[period_id]']")

    if (!($employee.val() && $period.val())){
      return false
    }

    $.ajax({
      url: window.location.href + "/fetch",
      data: {
        employee_id: $employee.val(),
        period_id: $period.val(),
      },
      dataType: 'script',
      beforeSend: function() {
        $employee.attr('disabled', 'disabled')
        $period.attr('disabled', 'disabled')
        $('#employee-work-calendar-detail').html(`<tr><td colspan="20" class="py-1">${setSpinner()}</td></tr>`)
      },
      success: function(res) {
        $('#employee-work-calendar-detail').html(res)
      },
      error: function(jqXHR) {
        alert("Error: Something wen't wrong!")
      },
      complete: function() {
        $employee.removeAttr('disabled')
        $period.removeAttr('disabled')
      }
    })
  })
})